// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ExternalSubscriptionRequestDetailController = function ($scope, $routeParams, $http, ExternalSubscriptionRequestLog, $window) {
    $scope.requestLog = ExternalSubscriptionRequestLog.get({ id: $routeParams.id }, function (data) {
        $scope.response = JSON.stringify(JSON.parse(data.Response), null, 2);
    });

    $scope.back = function () {
        $window.history.back();
    };
};
ExternalSubscriptionRequestDetailController.$inject = ['$scope', '$routeParams', '$http', 'ExternalSubscriptionRequestLog', '$window'];
